import httpManager from "@/app/shared/utils/httpManager";
import { FormVar } from "@/@types/manageVars";

/**
 * Crea una variable
 * @return {Promise<Object>} variable.
 */
export async function updateVar({ id, name, exclude_words }: FormVar) {
  try {
    if (!id) return { success: false };
    const response = await httpManager.put(`variables/${id}/`, {
      name,
      exclude_words,
    });
    return { success: true, data: response.data };
  } catch (error) {
    console.error(error);
    return { success: false };
  }
}
